import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRecentMessages,
  MessageItem,
  RecentMessageData,
} from "../../apis/recentMessageApis";

interface RecentMessageState {
  messages: MessageItem[];
  count: number;
  loading: boolean;
  error: string | null;
}

const initialState: RecentMessageState = {
  messages: [],
  count: 0,
  loading: false,
  error: null,
};

/* =======================
   FETCH MESSAGES
======================= */

export const fetchRecentMessages = createAsyncThunk<
  RecentMessageData,
  { pageId?: number; limit?: number },
  { rejectValue: string }
>("recentMessages/fetchRecentMessages", async (params, { rejectWithValue }) => {
  try {
    const { pageId = 1, limit = 10 } = params || {};

    const response = await getRecentMessages(pageId, limit);

    if (!response.status) {
      return rejectWithValue("Failed to fetch messages");
    }

    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message || "Something went wrong",
    );
  }
});

/* =======================
   SLICE
======================= */

const recentMessageSlice = createSlice({
  name: "recentMessages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecentMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.rows;
        state.count = action.payload.count;
      })
      .addCase(fetchRecentMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch messages";
      });
  },
});

export default recentMessageSlice.reducer;
